import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { isMobile } from 'react-device-detect'
import styled from 'styled-components'
import { getCurrency } from 'core/utils/cultures/unit'
import { Row, Col, Radio } from 'core/components/ui'
import { font, greys } from 'assets/themes/theme-default'
import { configuratorShape } from '../../../shapes'

const ClickableRow = styled(Row)`
  cursor: pointer;
`

const ColDataInput = styled(Col)`
  padding-top: 2px;
`

const ColDataLabel = styled(Col)`
  color: ${greys.dark3};
  font-weight: ${font.weight.base};
  line-height: ${isMobile && 'normal'};
  font-size: ${font.size.base};
  /*text-transform: none;*/
`

const ColDataValue = styled(Col)`
  text-align: right;
  color: ${props => props.theme.colors.color2.bg};
  font-weight: ${font.weight.bold};
  font-size: ${font.size.base};
`

const TypeColorItem = props => {
  const { item, configurator, setConfigurator, showCheckBox } = props

  const { design } = configurator
  const typeSelected = design.exterior.type

  const handleClick = () => {
    setConfigurator({
      ...configurator,
      design: {
        ...configurator.design,
        exterior: { ...configurator.design.exterior, type: item }
      }
    })
  }

  return (
    <ClickableRow
      type="flex"
      style={{ width: '100%' }}
      align="top"
      gutter={16}
      onClick={showCheckBox && handleClick}
      data-test="component-configurator-design-type-color-item"
    >
      {showCheckBox && (
        <ColDataInput lg={2} xs={3}>
          <Radio
            checked={!typeSelected ? false : item.id === typeSelected.id}
            data-test="configurator-design-type-color-item-radio"
          />
        </ColDataInput>
      )}

      <ColDataLabel lg={18} xs={15} data-test="configurator-design-type-color-item-label">
        {item.label}
      </ColDataLabel>
      <ColDataValue lg={4} xs={6} data-test="configurator-design-type-color-item-priceWrapper">
        {!item.serial ? (
          <>
            <FormattedMessage
              id="configurator-design-card-1-price"
              values={{ price: item.price }}
              data-test="configurator-design-type-color-item-price-formattedPrice"
            />{' '}
            {getCurrency()}
          </>
        ) : (
          <FormattedMessage
            id="configurator-design-card-1-included"
            data-test="configurator-design-type-color-item-price-included"
          />
        )}
      </ColDataValue>
    </ClickableRow>
  )
}
TypeColorItem.defaultProps = {
  showCheckBox: true
}

TypeColorItem.propTypes = {
  item: PropTypes.shape().isRequired,
  setConfigurator: PropTypes.func.isRequired,
  configurator: configuratorShape.isRequired,
  showCheckBox: PropTypes.bool
}

export default TypeColorItem
